import React, { useMemo } from "react";

import { Box } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";

import RoundChip from "design-system/components/RoundChip";
import { rideStatusLabelColors, grayMedium, black } from "design-system/colors";
import { Trip } from "types";

const DEFAULT_STATUS_COLORS = {
  backgroundColor: grayMedium,
  color: black,
};

function DriverStatusColumn(props: GridRenderCellParams<Trip>) {
  const { row } = props;

  const dispatchStatus = row.routes?.[0]?.dispatchStatus;

  const getStatusDisplay = (status: string) => {
    const colorScheme =
      rideStatusLabelColors[status.toLowerCase()] || DEFAULT_STATUS_COLORS;

    return {
      ...colorScheme,
      label: status.toUpperCase().replace(/-/g, " "),
    };
  };

  // memoize the status display
  const statusDisplay = useMemo(
    () => getStatusDisplay(dispatchStatus),
    [dispatchStatus]
  );

  if (!dispatchStatus) {
    return null;
  }

  return (
    <Box display="flex" justifyContent="center">
      <RoundChip {...statusDisplay} />
    </Box>
  );
}

export default DriverStatusColumn;
